import styled from 'styled-components'
import { Tabs } from 'antd'

const AntTabsStyled = styled(Tabs)``

export default AntTabsStyled
